import { Component, Input, OnDestroy, OnInit, ViewChild, AfterViewInit, ElementRef, HostListener, ViewChildren, QueryList, PLATFORM_ID, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { BenefitsService } from 'src/app/services/api/benefits/benefits.service';
import { SliderService } from 'src/app/services/api/sliders/slider.service';
import { SorteosService } from 'src/app/services/api/sorteos/sorteos.service';
import SwiperCore, { SwiperOptions, Navigation, Pagination, Thumbs, Swiper } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { assetUrl } from 'src/app/globals/globals';
import { BannerItemDesktop, BannerItemMobile, sliderType } from 'src/app/interfaces/banners/banners.interface';
import { isPlatformBrowser } from '@angular/common';

SwiperCore.use([Pagination, Thumbs]);

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('swiperHero', { static: false }) swiperHero?: SwiperComponent;
  @ViewChild('swiperHeroMobile', { static: false }) swiperHeroMobile?: SwiperComponent;
  @ViewChild('thumbsSwiperRef', { static: false }) thumbsSwiperRef?: SwiperComponent;
  @ViewChild('sliderRef', { static: false }) sliderRef?: SwiperComponent;
  @ViewChildren('videoDesktop') videoDesktopElements!: QueryList<ElementRef<HTMLVideoElement>>;
  @ViewChildren('videoMobile') videoMobileElements!: QueryList<ElementRef<HTMLVideoElement>>;
  assetUrl = assetUrl;

  currentUser: any;
  guestUser: boolean = true;
  sliders: any = [];
  thumbsSwiper?: Swiper;
  slider?: Swiper;
  slidersBenefit? : any = [];
  bannerListDesktop: BannerItemDesktop[] = [];
  bannerListMobile: BannerItemMobile[] = [];
  onBoarding = { show: true, step: 1}
  benefits: any = [];
  showSlider: boolean = false;
  slider_Type: sliderType;
  sorteos: any = [];
  benefitsHero: any = [];
  benefitsHeroDiscount: any = [];
  redeemCodes: boolean = false;
  @Input() dashboard: boolean;
  sorteosDisplay: any = [];
  changeBanner: boolean = true;
  isMobile: boolean = false;
  showFirstPopup: boolean = true;
  private readonly _loginValidatedEvent: Event;
  private readonly _loginValidatedMktPlaceEvent: Event;
  private readonly _changePasswordEvent: Event;
  private readonly _ingresarEvent: Event;

  options = [
    {
      imageSrc: 'assets/icon/icon-conversor.svg',
      title: 'Conversor de puntos',
      description: 'Convierte tus puntos en millas o tus millas en puntos.',
      link: '/conversor'
    },
    {
      imageSrc: 'assets/icon/icon-market-exchange.svg',
      title: 'Market Shell',
      description: 'Accede a precios especiales usando tus puntos.',
      link: 'https://marketshell.shell.com.ar/'
    }
  ];
  heroImages = [
    { path: '..//src/assets/images/hero/hero1.png' },
    { path: '..//src/assets/images/hero/hero2.png' },
  ];
  steps = [
    { numero: 1, titulo: 'Registrate', descripcion: 'Descargá la App y registrate con pocos pasos.' },
    { numero: 2, titulo: 'Sumá puntos', descripcion: 'Por cada compra que hagas sumás puntos.' },
    { numero: 3, titulo: 'Y usálos', descripcion: 'Podés canjear tus puntos por descuentos exclusivos.' }
  ];

  config: SwiperOptions = {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      clickable: true,
    },
    centeredSlides: true,
    slidesPerView: 1.1,
    breakpoints: {
      1280:{
        slidesPerView: 1.12,
      },
    },
    preventClicksPropagation: false,
  };
  configDraw: SwiperOptions = {
    loop: true,
    autoplay: true,
    initialSlide: 1,
    slidesPerView: 1.1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      type: 'bullets',
      dynamicBullets: true,
      clickable: true
    },
    preventClicksPropagation: false,
    speed: 600,
    centeredSlides: true,
    spaceBetween: 10,
    breakpoints: {
      1280:{
        slidesPerView: 1.12,
      }
    },
    thumbs: {
      swiper: this.thumbsSwiper as Swiper,
    },
    loopAdditionalSlides: 4,
    simulateTouch: true,
  };
  configHeader: SwiperOptions = {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      dynamicBullets: true,
      clickable: true,
    },
    slidesPerView: 1.1,
    breakpoints: {
      1280:{
        slidesPerView: 1.12,
      },
    },
    loop: true,
    preventClicksPropagation: false,
    speed: 600,
    centeredSlides: true,
    spaceBetween: 10,
    thumbs: {
      swiper: this.thumbsSwiper as Swiper,
    },
    loopAdditionalSlides: 40,
    initialSlide: 0
  };
  configHeaderMobile: SwiperOptions = {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      dynamicBullets: true,
      clickable: true,
    },
    slidesPerView: 1.1,
    loop: true,
    preventClicksPropagation: false,
    speed: 600,
    centeredSlides: true,
    spaceBetween: 10,
    thumbs: {
      swiper: this.thumbsSwiper as Swiper,
    },
    loopAdditionalSlides: 40,
    initialSlide: 0    
  };
  benefitsSlider: SwiperOptions = {
    slidesPerView: 4,
    spaceBetween: 40,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    rewind: true
  };
  optionsRedirect = {
    slidesPerView: 1.3,
    spaceBetween: 10,
    centeredSlides: true,
    pagination: true
  };
  imageSrc = this.isMobile ? '../../../assets/images/downloadShellMobile.png' : '../../../assets/images/downloadShellDesktop.png';


  constructor(
    private benefitsService: BenefitsService,
    private sliderService: SliderService,
    private sorteosService: SorteosService,
    public authService: AuthService,
    private route:ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this._loginValidatedEvent = new Event('loginValidated');
    this._loginValidatedMktPlaceEvent = new Event('loginValidatedMktPlace');
    this._changePasswordEvent = new Event('changePassword');
    this._ingresarEvent = new Event('ingresar');
  }

  async ngOnInit(): Promise<any> {
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('UserSessionRefreshed', (e: Event) => {
        this.handleUser();
      }, false); 
    }
    const targetDate = new Date('2025-05-18T23:59:00');
    const currentDate = new Date();
    this.showFirstPopup = currentDate < targetDate;
    this.checkDate();
    this.handleUser();
    this.getBenefits();
    this.getSliders();
    this.getSorteos();
    this.getBannerImageSrc();
    this.getBannerImageSrcMobile();
    this.checkShowSlider();
    this.getCurrentDay();
    this.getSliderBenefits();
    if((this.route.snapshot.routeConfig?.path == 'ingresar') && isPlatformBrowser(this.platformId)) {
      document.dispatchEvent(this._ingresarEvent);
    }

    if(this.route.snapshot.routeConfig?.path == 'cambiar-password') {
      this.route.queryParams.subscribe((params:any) => {
        if( (params.principal && params.token) && isPlatformBrowser(this.platformId) ) {
          document.dispatchEvent(this._changePasswordEvent);
        }
      });
    }
    else if(this.route.snapshot.routeConfig?.path == 'validar-marketplace') {
      this.route.queryParams.subscribe((params:any) => {
        if( (params.principal && params.token) && isPlatformBrowser(this.platformId) ) {
          document.dispatchEvent(this._loginValidatedMktPlaceEvent);
        }
      });
    }
    else {
      this.route.queryParams.subscribe((params:any) => {
        if( (params.principal && params.token) && isPlatformBrowser(this.platformId) ) {
          document.dispatchEvent(this._loginValidatedEvent);
        }
      });
    }
  }

  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth <= 800;
    }
  }

  transformVideoLink(url: string): string {
    if (url.includes("youtube.com/watch")) {
      const videoId = url.split("watch?v=")[1].split("&")[0];
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&showinfo=0&loop=1&mute=1&playlist=${videoId}`;
    }
    return url;
  }  
  
  isGif(url: string | null | undefined): boolean {
    return url?.toLowerCase().endsWith('.gif') || false;
  }

  checkDate(): void {
    const currentDate = new Date();
    const targetDate = new Date('2024-12-01T23:59:00');
    this.changeBanner = currentDate < targetDate;
  }

  async getSliderBenefits(): Promise<void> {
    try {
      const sliders = await this.sliderService.getSliderBenefits().toPromise();
  
      this.slidersBenefit = sliders || [];  
    } catch (error) {
      console.error('Error fetching slider benefits:', error);
    }
  }
  
  async ngOnDestroy()
  {
    if (isPlatformBrowser(this.platformId)) {
    let aux: any = await sessionStorage.getItem('user');
    if (aux) {
      aux = JSON.parse(aux);
      aux.person.profile.onboarding_shellbox = true;
      if (isPlatformBrowser(this.platformId)) {
        sessionStorage.setItem('user', JSON.stringify(aux));
      }
    }
    if (this.slider) {
      this.slider.destroy(true, true);
    }
  }
}

  ngAfterViewInit(): void {
    this.thumbsSwiper = this.thumbsSwiperRef?.swiperRef;
    this.slider = this.sliderRef?.swiperRef;
    this.initializeSwiper();
  
    if (this.swiperHero?.swiperRef) {
      this.swiperHero.swiperRef.on('slideChange', () => {
        this.swiperHero?.swiperRef.pagination.update();
      });
    }
    this.videoDesktopElements?.changes.subscribe(() => {
      this.playVideo(this.videoDesktopElements, 'desktop');
    });
    this.videoMobileElements?.changes.subscribe(() => {
      this.playVideo(this.videoMobileElements, 'mobile');
    });
    this.playVideo(this.videoDesktopElements, 'desktop');
    this.playVideo(this.videoMobileElements, 'mobile');
  }
  
  private playVideo(videos: QueryList<ElementRef>, tipo: 'desktop' | 'mobile'): void {
    if (!videos) return;
  
    videos.forEach((videoRef) => {
      const video = videoRef.nativeElement as HTMLVideoElement;
      if (video) {
        video.muted = true;
        video.play().catch((error) => {
          console.error('Error:', error);
        });
      }
    });
  }

  initializeSwiper(): void {
    if (this.swiperHero && this.swiperHero.swiperRef) {
      this.slider = this.swiperHero.swiperRef;
    }
    if (this.swiperHeroMobile && this.swiperHeroMobile.swiperRef) {
      this.slider = this.swiperHeroMobile.swiperRef;
    }
  }

  checkShowSlider() {
    return this.sorteosDisplay.length > 0;
  }

  onLoginSuccess(): void {
    this.authService.IsLoggedIn().then(() => {
      const redirectUrl = sessionStorage.getItem('redirectUrl');
      this.router.navigateByUrl(redirectUrl || '/');
      sessionStorage.removeItem('redirectUrl');
    });
  }  

  getPictureItem(item: any) {
    if (isPlatformBrowser(this.platformId)) {
      if(window.innerWidth < 800)
          return item.benefit?item.benefit.photo_mobile:item.photo_mobile;
      else
          return item.benefit?item.benefit.photo:item.photo;
    }
    return '';
  }

  getBannerImageSrc(code?: string): string {
    if (code === 'sorteo_trap_domingo1') {
      return '../../../assets/images/banner/bannerDomingo.png';
    } else if (code === 'sorteo_trap_sabado') {
      return '../../../assets/images/banner/bannerSabado.png';
    }
    return '';
  }

  getBannerImageSrcMobile(code?: string): string {
    if (code === 'sorteo_trap_domingo1') {
      return '../../../assets/images/banner/bannerDomingoMobile.png';
    } else if (code === 'sorteo_quevedo') {
      return '../../../assets/images/banner/bannerQuevedoMobile.png';
    } else if (code === 'sorteo_trap_sabado') {
      return '../../../assets/images/banner/bannerSabadoMobile.png';
    }
    return '';
  }

  async goToConversor() {
    if(await this.authService.IsLoggedIn()) {
      if (isPlatformBrowser(this.platformId)) {
        document.location.href = "/conversor";
      }
    } else {
      if (isPlatformBrowser(this.platformId)) {
        document.getElementsByClassName('modal-login')[0].classList.add('visible');
        document.getElementsByTagName('body')[0].classList.add('noScroll');
      }
    }
  }

  getCurrentDay(): string {
    const today = new Date().getDay().toString();
    return today === '0' ? '7' : today;  
  }
  

  getBenefits() {
    this.benefitsService
      .get()
      .toPromise()
      .then((benefits: any) => {
        this.benefitsHero = benefits.filter((element: any) => {
          return (
            element.starred_home
          );
        });

        this.benefits = benefits;
      });
  } 

  getSorteos(): void {
    this.sorteosService.getSorteos().subscribe((data: any[]) => {
      if (data && data.length > 0) {
        data.forEach((item: any) => {
          switch (item.description11) {
            case 'alineacion_a1': item.description11 = 'A1 LEFT'; break;
            case 'alineacion_a2': item.description11 = 'A1 RIGHT'; break;
            case 'alineacion_a3': item.description11 = 'A2 LEFT'; break;
            case 'alineacion_a4': item.description11 = 'A2 RIGHT'; break;
            case 'alineacion_a5': item.description11 = 'A3 BACKGROUND'; break;
            case 'alineacion_a6': item.description11 = 'A3 NO BACKGROUND'; break;
            case 'alineacion_a7': item.description11 = 'A5'; break;
            default: break;
          }
        });
  
        const sorteosAbiertos = data.filter((item: any) => item.description5 === 'Abierto');
  
        this.sorteos = sorteosAbiertos;
    
        this.sorteosDisplay = sorteosAbiertos.filter((item: any) => {
          const now = new Date();
          const beginning = new Date(item.beginningDate);
          const expiration = new Date(item.expirationDate);
    
          return (
            (beginning <= now && expiration >= now) ||
            (expiration < now && item.description7 != null && item.description7.length > 0)
          );
        });
      } else {
        console.log('No se encontraron sorteos');
      }
    });
    
  }


  getSorteosAbiertos(): any[] {
  return this.sorteos.items || [];
}



  getItemValue(item: any, property: string, index: number): string {
    const value = item[property];
    if (value) {
      const parts = value.split(';');
      return parts[index] || '';
    }
    return '';
  }

 modifiedValue(item: any, property: string): string {
    const value = item[property];
    if (value) {
      const parts = value.split(';');
      const transformedParts = parts.map((part: string) => part.split('|')[0].trim());
      const transformedString = transformedParts.join(', ');
      return transformedString;
    }
    return '';
  }

  updateSliderMobile() {
    if (this.swiperHeroMobile) {
      this.bannerListMobile = this.sliders.map((slider: any) => {
        return { imgUrlMobile: slider.photo_mobile };
      });
    }
  }

  updateSliderDesktop() {
    if (this.swiperHero) {
      this.bannerListDesktop = this.sliders.map((slider: any) => {
        return { imgUrl: slider.photo };
      });
    }
  }

  getSliders() {
    this.sliderService.getCurrent().subscribe((benefits: any) => {
      this.sliders = benefits.filter((e: any) => e.slider_Type.name == 'Home').sort((a: any, b: any) => a.order - b.order);
      this.updateSliderDesktop();
      this.updateSliderMobile();
    });
  }

  slideNext(){
    this.swiperHero?.swiperRef.slideNext(100);
  }
  slidePrev(){
    this.swiperHero?.swiperRef.slidePrev(100);
  }

  slideNextMobile(){
    this.swiperHeroMobile?.swiperRef.slideNext();
  }
  slidePrevMobile(){
    this.swiperHeroMobile?.swiperRef.slidePrev();
  }

  async handleUser(){
    this.currentUser = await this.authService.getCurrentUser();

    const userToken = await this.authService.getAccessToken();

    this.guestUser = !(userToken != null && userToken.length > 0);
  }

}
